import React from 'react';
import { useTheme } from '@emotion/react';
import Wrapper from '../tlyfePages/Wrapper';
import ODSPlanSelector from '../../../openbrix-design-system/ui/molecules/PlanSelector';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { buyBasicPlan, getSubscriptionPlans } from '../../redux/actions/auth';
import { StyleSheet, View } from 'react-native';
import getPlatformType from '../../helpers/getPlatform';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Elements } from '@stripe/react-stripe-js';
import { STRIPEKEY } from '../../helpers/connectionHelpers';
import { tenantActions } from '../openFlow/openFlowRedux/tenant.actions';
import CheckoutForm from '../idVerification/checkoutForm';
import { navigate } from '../../navigation/RootNavigation';
import { types } from '../../redux/actionTypes';
import { cancelRewardSubscription, cancelSubscription, getCreditLadderHistory, startPayment } from '../../redux/actions/Ladger';
import PlanCard from '../../../openbrix-design-system/ui/atoms/ODSPlanCard';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import BackButton from '../../commonComponents/BackButton';
import { useNavigation, useRoute } from '@react-navigation/native';
import CustomPopUp from '../../commonComponents/customPopUp/customPopUp.web';
import moment from 'moment';
import Loader from '../../commonComponents/activityIndicator/activityIndicator.web';
import { buttonPressEvent } from '../../helpers/analytics';

const HeaderWeb = require('../../../openbrix-design-system/images/tlyfe-pages/i-desktop.png');
const HeaderTab = require('../../../openbrix-design-system/images/tlyfe-pages/i-tab.png');
const HeaderMobile = require('../../../openbrix-design-system/images/tlyfe-pages/login-mobile.png');
const FooterWeb = require('../../../openbrix-design-system/images/tlyfe-pages/introduction/footer-web.png');
const FooterTab = require('../../../openbrix-design-system/images/tlyfe-pages/introduction/footer-tab.png');
const FooterMobile = require('../../../openbrix-design-system/images/tlyfe-pages/introduction/footer-mobile.png');



const TlyfePlan = (props) => {
  const { colors } = useTheme();
  const routes = useRoute();
  const layout = getPlatformType();
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const [plans, setPlans] = useState([]);
  const [clientSecret, setClientSecret] = React.useState('');
  const [currentView, setCurrentView] = useState('plans');
  const [currentPlanName, setCurrentPlanName] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const hasUserSavedCookies = useSelector(
    (state) => state?.cookiesReducer?.userHasSavedCookiesPreferences
  );
  const clhData = useSelector((state) => state.ladgerReducer.clhData);
  const [popUpIsVisible, setpopUpIsVisible] = useState(false);
  const [cancelVBpopup, setCancelVBpopup] = useState(false);
  const [chunkPopup, setChunkPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(null);

  const authDataFromMobile = useSelector((state) => state?.appReducer?.mobileData?.data?.isWebView);

  let stripePromise = null;
  if (hasUserSavedCookies) {
    stripePromise = loadStripe(STRIPEKEY);
  }
  if (authDataFromMobile) {
    stripePromise = loadStripe(STRIPEKEY);
  }
  const handlePlanChange = (planId) => {
    const resolvedPlan = (plans || []).find((p) => p?.id === planId);
    if (resolvedPlan) {
      setSelectedPlan(resolvedPlan);
    }
  };

  useEffect(() => {
    dispatch(getCreditLadderHistory({}, navigation.navigate));
    dispatch(
      getSubscriptionPlans(routes?.params?.onRegistration ? true : false, (data) => {
        const fetchedPlans = data.plans;
        const currentPlanId = data.currentPlanId;
        setCurrentPlanName(currentPlanId);

        // Filter out the plan that matches currentPlanId
        const filteredPlans = fetchedPlans ? routes?.params?.from ? fetchedPlans.filter(plan => plan.id !== currentPlanId) : fetchedPlans : [];

        setPlans(filteredPlans || []);
        if (Array.isArray(filteredPlans) && filteredPlans.length > 0) {
          setSelectedPlan(filteredPlans[0]);
        }
      })
    );

  }, []);
  const calculateDaysLeft = (status, voluntaryChurnAt) => {
    if (status === "voluntary_churn" || status === "ended") {
      const voluntaryChurnDate = new Date(voluntaryChurnAt);
      const allowedDate = new Date(voluntaryChurnDate);
      allowedDate.setDate(voluntaryChurnDate.getDate() + 90);

      const today = new Date();
      const timeDiff = allowedDate - today;
      const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

      return daysLeft > 0 ? daysLeft : 0;
    }
    return null;
  };
  const checkVoluntaryChurn = calculateDaysLeft(clhData?.user_data?.status, clhData?.user_data?.voluntary_churn_at);
  const loadPaymentForPremium = () => {
    if (checkVoluntaryChurn) {
      setChunkPopup(true)
      return;
    }
    dispatch(
      startPayment((response) => {
        if (window?.ReactNativeWebView && isMobilePaymentRequire) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              val: {
                type: 'payment',
                clientSecret: response?.clientSecret,
              },
            })
          );
        } else {
          setClientSecret(response.clientSecret);
          setTimeout(
            function () {
              setCurrentView('payment');
            }.bind(this),
            1000
          );
        }
      })
    );
  };
  const loadPaymentForExtra = () => {
    let payload = {
      productId: 1001,
    };
    dispatch(
      tenantActions.startPayment(
        payload,
        (data) => {
          console.log('startPayment datadatadata', data);
          if (data?.status) {
            setClientSecret(data?.data?.clientSecret);
            setCurrentView('payment');
          } else {
            dispatch(showToaster('error', 'Failed to start payment'));
          }
        },
        true
      )
    );
  };
  const cancelSubscription1 = () => {
    setpopUpIsVisible(false);
    dispatch(
      cancelSubscription(() => {

        if (currentPlanName == "tlyfe-premium" && selectedPlan?.id == "tlyfe-extra") {
          loadPaymentForExtra();
          return;
        }
        const parseRoutes = JSON.parse(routes?.params?.routes);
        navigation.reset({
          index: 0,
          routes: [parseRoutes],
        });
      })
    );
  };
  const cancelVBSubscription = () => {
    setCancelVBpopup(false);
    dispatch(
      cancelRewardSubscription(false, () => {
        const parseRoutes = JSON.parse(routes?.params?.routes);
        navigation.reset({
          index: 0,
          routes: [parseRoutes],
        });
      })
    );
  };

  const loadPayment = () => {
    buttonPressEvent("Checkout Pressed " + selectedPlan?.id, "Plans");
    if (selectedPlan?.id === 'tlyfe-premium') {
      loadPaymentForPremium();
    } else {
      if (currentPlanName == "tlyfe-premium" && selectedPlan.id == "tlyfe-extra") {
        setpopUpIsVisible(true);
        return;
      }
      loadPaymentForExtra();
    }
  };

  const paymentView = () => {
    // Guard: render nothing until we have a valid clientSecret and a stripe instance
    if (!clientSecret || !stripePromise) {
      return null;
    }
    const options = { clientSecret };
    return (
      <View style={{ padding: 20 }}>
        <View style={{ alignItems: 'center', flexDirection: layout == "phone" ? 'column' : 'row', justifyContent: 'center' }}>
          <ODSButton
            restStyle={{
              position: 'absolute',
              height: 40,
              left: 0,
              top: 0
            }}
            themeColor={colors.main.purple}
            onPress={() => setCurrentView('plans')}
          >
            ← All Plans
          </ODSButton>
          <ODSText type='h4' textAlign='center' marginTop={layout == "phone" ? 60 : 20} color={colors.text.primary} marginBottom={20} >You Selected:</ODSText>
        </View>

        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
          <PlanCard
            {...selectedPlan}
            type={'single'}
            onRegistration={routes?.params?.onRegistration}
          />
        </View>
        <View style={{ height: 20 }} />
        {(authDataFromMobile || hasUserSavedCookies) ? (
          <Elements stripe={stripePromise} options={options}>
            <CheckoutForm
              onSuccessToken={(success) => {
                if (success) {
                  setLoading(true);
                  setLoadingMessage("We are processing your payment");
                  setTimeout(() => {
                    setLoading(false);
                    setLoadingMessage(null);
                    if (routes?.params?.routes) {
                      const parseRoutes = JSON.parse(routes?.params?.routes);
                      navigation.reset({
                        index: 0,
                        routes: [parseRoutes],
                      });
                    }
                    else {
                      navigation.reset({
                        index: 0,
                        routes: [{ name: 'Dashboard' }],
                      });
                    }
                  }, 3000);
                  dispatch({ type: types.SHOW_ALERT, alertType: "success", text: "Payment Success" });
                } else {
                  dispatch({ type: types.SHOW_ALERT, alertType: "erorr", text: "Payment Failed" });
                }
              }}
            />
          </Elements>
        ) : null}
      </View>
    );
  };


  return (
    <>
      <Wrapper
        theme={routes?.params?.routes ? '#cf84a970' : colors.transparency.purple}
        type="plans"
        drawerColor={colors.theme.purple}
        headerImage={routes?.params?.headerImg ? routes?.params?.headerImg : layout == 'web' ? HeaderWeb : layout == 'tab' ? HeaderTab : HeaderMobile}
      >
        {loading && <Loader loading={loading} message={loadingMessage} />}
        {routes?.params?.from && <ODSButton onPress={() => {
          const parseRoutes = JSON.parse(routes?.params?.routes);
          navigation.navigate(parseRoutes?.name, parseRoutes?.params)
        }
        } type='secondary' themeColor={colors.main.purple} restStyle={{ position: 'absolute', left: layout == "phone" ? 20 : 50, top: layout == 'phone' ? 100 : 120, height: 48 }}>←  {routes?.params?.from}</ODSButton>}
        <View style={styles(layout).container}>
          {currentView === 'plans' ? (
            <>
              <ODSPlanSelector
                plans={plans || []}
                onPlanSelect={handlePlanChange}
                selectedPlanId={selectedPlan?.id}
                onRegistration={routes?.params?.onRegistration}
                currentPlan={routes?.params?.from && currentPlanName}
              />
              <View style={{ paddingRight: layout != 'phone' ? 32 : 0 }}>
                {selectedPlan?.id === 'tlyfe-basic' ? (
                  <ODSButton
                    restStyle={{ width: 300, alignSelf: layout == "phone" ? 'center' : 'flex-end', marginBottom: 40, height: 48 }}
                    themeColor={colors.main.purple}
                    onPress={() => {
                      if (routes?.params?.routes) {
                        currentPlanName == "tlyfe-extra" ? setCancelVBpopup(true) : setpopUpIsVisible(true);
                      }
                      else {
                        dispatch(buyBasicPlan(cb => {
                          setLoading(true);
                          setLoadingMessage("We are processing your payment");
                          setTimeout(() => {
                            setLoading(false);
                            setLoadingMessage(null);
                            navigation.reset({
                              index: 0,
                              routes: [{ name: 'Dashboard' }],
                            })
                          }, 3000);
                        }))

                      }
                    }
                    }
                  >
                    Subscribe to tlyfe Basic
                  </ODSButton>
                ) : (
                  <>
                    <ODSText
                      type="xs"
                      color={colors.text.secondary}
                      width={300}
                      alignSelf={layout == "phone" ? 'center' : 'flex-end'}
                      marginBottom={16}
                    >
                      By clicking Checkout, you are accepting our terms and conditions and you are waiving any right to cancel, under the consumer contracts regulations 2013
                    </ODSText>
                    <ODSButton
                      restStyle={{ width: 300, alignSelf: layout == "phone" ? 'center' : 'flex-end', marginBottom: 40, height: 48 }}
                      themeColor={colors.main.purple}
                      onPress={loadPayment}
                    >
                      Checkout
                    </ODSButton>
                  </>
                )}
              </View>
            </>
          ) : (
            paymentView()
          )}
        </View>

      </Wrapper>
      <CustomPopUp
        loading={popUpIsVisible}
        primaryButtonText={'Sure'}
        secondaryButtonText={'Back'}
        primaryText={'Cancel Subscriptions ?'}
        secondaryText={' Are you sure you want to Cancel Subscriptions?'}
        onPrimaryButtonPress={() => {
          cancelSubscription1();
        }}
        note={
          'that by cancelling this product your monthly rent will not be recorded on your credit file with UK largest credit reference agencies. Many banks and financial institutions use these agencies when giving you credit and loans. This can materially impact your interest on credit cards and loans. Furthermore due to open banking regulation, once cancelled we would require 45 days to reconnect to your bank.'
        }
        onSecondaryButtonPress={() => {
          setpopUpIsVisible(false);
        }}
      />
      <CustomPopUp
        loading={cancelVBpopup}
        primaryButtonText={'Sure'}
        secondaryButtonText={'Back'}
        primaryText={'Cancel Subscriptions ?'}
        secondaryText={' Are you sure you want to Cancel Subscriptions?'}
        onPrimaryButtonPress={() => {
          cancelVBSubscription();
        }}
        onSecondaryButtonPress={() => {
          setCancelVBpopup(false);
        }}
      />
      <CustomPopUp
        loading={chunkPopup}
        primaryButtonText={'Okay'}
        // secondaryButtonText={'Back'}
        primaryText={'Unfortunately you cannot re-subscribe to this plan yet.'}
        secondaryText={`You voluntarily canceled your subscription on the ${moment(clhData?.user_data?.voluntary_churn_at).format('DD-MM-YYYY')}. You will be able to resubscribe ${checkVoluntaryChurn} days after this date.`}
        onPrimaryButtonPress={() => {
          setChunkPopup(false)
        }}
      />
    </>
  );
};
const styles = (props) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    ...(props !== 'phone' && {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
      minWidth: '60%',
      alignSelf: 'center',
      top: -100,
      borderRadius: 10

    }),
  },
});
export default TlyfePlan;
